<template>
  <div class="meeting-container" v-if="meeting">
    <div class="meeting-layout-top">
      <div class="meeting-top-container">
        <div class="meeting-top-logo">
          <img src="../assets/images/p-logo.svg" @click="goToOrganization" />
        </div>

        <div class="meeting-top-back">
          <v-btn class="white--text" icon @click="goToOrganization">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </div>

        <div class="meeting-top-left">
          <h3 class="white--text">
            {{ meeting.organizationName }} - {{ meeting.name }}
          </h3>
        </div>

        <div class="meeting-top-right">
          <v-menu offset-y right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="white" text v-bind="attrs" v-on="on">
                <div class="icon-button-container">
                  <div class="icon-button-text">
                    Hantera möte
                  </div>
                  <div class="icon-button-icon">
                    <v-icon right style="color: rgba(255,255,255,1);">
                      mdi-menu-down
                    </v-icon>
                  </div>
                </div>
              </v-btn>
            </template>

            <v-list>
              <edit-meeting
                :meeting="meeting"
                :organization="organization"
              ></edit-meeting>

              <!--              <v-list-item @click="gotoMembers">-->
              <!--                <v-list-item-icon>-->
              <!--                  <v-icon>mdi-account-group</v-icon>-->
              <!--                </v-list-item-icon>-->
              <!--                <v-list-item-content>-->
              <!--                  <v-list-item-title>Medlemmar</v-list-item-title>-->
              <!--                </v-list-item-content>-->
              <!--              </v-list-item>-->

              <v-divider></v-divider>
              <upload-agenda-items
                :meetingId="meeting.id"
              ></upload-agenda-items>
              <upload-ballots
                :meetingId="meeting.id"
                :weightedVotes="isWeightedVotes"
              ></upload-ballots>
              <v-divider></v-divider>

              <files :meeting="meeting"></files>

              <v-divider></v-divider>
              <invite :disabled="state !== 4" :meeting="meeting"></invite>

              <v-list-item :disabled="state != 2" @click="registerAllMembers()">
                <v-list-item-icon>
                  <v-icon>mdi-check-all</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    >Närvaroregistrera samtliga medlemmar</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>
              <v-list-item
                :disabled="state < 2"
                :href="screenUrl(meeting)"
                target="_blank"
              >
                <v-list-item-icon>
                  <v-icon>mdi-projector-screen</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Öppna projektorvy</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                :disabled="state < 2"
                :href="manualVotesUrl(meeting)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-ballot</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Sätt i röstningskiosk-läge
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                :disabled="!(meeting.videoLink && state < 4)"
                :href="meeting.videoLink"
                target="_blank"
              >
                <v-list-item-icon>
                  <v-icon>mdi-video</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Öppna videomöte</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <BallotsStats :meeting="meeting"></BallotsStats>

              <v-divider></v-divider>
              <v-list-item
                :disabled="!meeting.reportAvailable && state !== 4"
                @click="downloadReport()"
              >
                <template v-if="state !== 4">
                  <v-list-item-icon>
                    <v-icon>mdi-download-off</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >Mötesrapport ej tillgänglig
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-else>
                  <template v-if="meeting.reportAvailable">
                    <v-list-item-icon>
                      <v-icon>mdi-download</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        >Ladda ner mötesrapport
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-icon>
                      <v-icon>mdi-progress-download</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        >Mötesrapport skapas..
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-list-item>
              <v-list-item
                :disabled="!meeting.paidFor"
                @click="downloadReceipt()"
              >
                <template v-if="meeting.paidFor">
                  <v-list-item-icon>
                    <v-icon>mdi-download</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >Ladda ner betalningskvitto
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-icon>
                    <v-icon>mdi-download-off</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title :disabled="true"
                      ><span>
                        Ladda ner betalningskvitto (efter betalkort debiterats)
                      </span>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="meeting-top-middle">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="white" text v-bind="attrs" v-on="on">
                <div class="icon-button-container">
                  <div class="icon-button-text">
                    {{ getStateText() }}
                  </div>
                  <div class="icon-button-icon">
                    <v-icon right style="color: rgba(255,255,255,1);">
                      mdi-menu-down
                    </v-icon>
                  </div>
                </div>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="stateItem in stateItems"
                :key="stateItem.value"
                :disabled="stateItem.disabled"
                @click="changeState(stateItem.value)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ stateItem.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="meeting-top-usermenu">
          <user-menu></user-menu>
        </div>
      </div>
    </div>
    <agenda :meeting="meeting" :isOpen="isOpen"></agenda>
    <div class="meeting-middle-top row-container">
      <div class="row-left">
        <h2 class="white--text">Beslutspunkter</h2>
      </div>
      <div class="row-icon">
        <create-decision-point
          :meetingId="meeting.id"
          :weightedVoteOptional="weightedVoteOptional"
        ></create-decision-point>
      </div>
    </div>
    <div class="meeting-middle-content" v-if="decisionPoints.length > 0">
      <v-card
        elevation="1"
        style="margin-bottom: 12px;margin-right: 4px;"
        class="background--color-c"
        v-for="point in decisionPoints"
        :key="point.id"
      >
        <v-card
          v-on:click="toggleVisible(point.id)"
          style="user-select: none;"
          :class="[point.closed ? 'background--transparent' : '']"
        >
          <div class="decision-container">
            <div class="decision-icon">
              <v-icon style="padding-right: 5px">mdi-vote</v-icon>
            </div>
            <div class="decision-text subtitle-2">
              {{ point.text }}
            </div>
            <div class="decision-edit"></div>
            <div class="decision-unfold">
              <v-icon v-if="isVisible(point.id)">mdi-chevron-up</v-icon>
              <v-icon v-else>mdi-chevron-down</v-icon>
            </div>
          </div>
        </v-card>
        <v-card light class="background--color-c" v-if="isVisible(point.id)">
          <v-card-actions>
            <v-btn
              dark
              v-if="isOpen && !point.closed && !point.opened"
              text
              @click="activatePoint(point)"
              >Öppna
            </v-btn>
            <v-btn
              dark
              v-if="isOpen && point.opened && !point.closed"
              text
              @click="deactivatePoint(point)"
            >
              Stäng
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon @click="copyDesicion(point)">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
            <div v-if="isDesicionEditable(point)">
              <edit-decision-point
                :meetingId="meeting.id"
                :decisionPoint="point"
                :weightedVoteOptional="weightedVoteOptional"
              ></edit-decision-point>
            </div>
          </v-card-actions>
          <v-row>
            <v-col v-if="point.results || point.preliminaryResult">
              <v-card-text style="padding-top: 0">
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="text-left">Alternativ</th>
                      <th class="text-left">Resultat</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="result in sortedResults(
                        point.results ? point.results : point.preliminaryResult
                      )"
                      :key="result.id"
                    >
                      <td>{{ translateResult(result.vote) }}</td>
                      <td>{{ result.result }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-col>
            <v-col v-else-if="point.alternatives">
              <v-card-text style="padding-top: 0">
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="text-left">Alternativ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="alt in point.alternatives" :key="alt.id">
                      <td>{{ alt }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-col>
            <v-col v-else>
              <v-card-text style="padding-top: 0">
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="text-left">Alternativ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Ja</td>
                    </tr>
                    <tr>
                      <td>Nej</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-card>
    </div>
    <div class="meeting-middle-content" v-else>
      <v-card
        light
        style="margin-bottom: 12px;margin-right: 4px; padding: 12px"
        class="white"
        v-if="hasStandardDecisions"
      >
        <v-select
          class="white--text"
          v-model="decisionsSelect"
          :items="Object.keys(standardDecisions)"
          label="Importera beslutspunkter"
        ></v-select>
        <v-btn text @click="fillDecisions">Importera</v-btn>
      </v-card>
      <div v-else class="white--text">Inga beslutspunkter inlagda.</div>
    </div>

    <div class="meeting-right">
      <div
        class="meeting-right-layout"
        style="flex-grow: 0; flex-shrink: 0; height:100%;"
        v-bind:style="{ width: ballotWidth }"
      >
        <speaker-time
          v-if="state === 3"
          class="meeting-right-top"
          :activeSpeakerId="activeSpeakerId.speakerId"
          :isActive="state === 3 && !!activeSpeakerId.speakerId"
        ></speaker-time>
        <div class="meeting-right-content">
          <ballots-and-mandates
            :meeting="meeting"
            :ballotsAndMandates="ballotsAndMandates"
            :weighted="isWeightedVotes"
            :state="state"
            v-if="state < 3"
          ></ballots-and-mandates>
          <v-card
            v-else-if="state < 5"
            dark
            class="overflow-y-scroll overflow-x-hidden background--color-c"
            style="display: flex; flex-flow: column; width: 100%; height: 100%"
          >
            <v-card style="border-radius: 0;" light flat>
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Sök"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
            </v-card>
            <v-simple-table style="border-radius: 0;" dense light>
              <thead>
                <tr>
                  <th
                    style="padding-left: 8px; width:  108px; max-width:  108px; min-width:  108px;"
                    class="text-left"
                  >
                    Röstsedlar
                  </th>
                  <th
                    style="padding: 0; width:  200px; max-width:  200px; min-width:  200px;"
                    class="text-left"
                  >
                    Namn
                  </th>
                  <th
                    style="padding: 0; width:  72px; max-width:  72px; min-width:  72px;"
                    class="text-left"
                    v-if="meeting.askToSpeak"
                  ></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="currentSpeaker" style="">
                  <td
                    style="padding-left: 8px; width:  108px; max-width:  108px; min-width: 108px; color: white; background: #627f90; border-bottom: thin solid rgba(0,0,0,.12)"
                  >
                    {{ currentSpeaker.ballots.join(", ") }}
                  </td>
                  <td
                    style="padding: 0px; width:  200px; max-width:  200px; min-width:  200px; color: white; background: #627f90; border-bottom: thin solid rgba(0,0,0,.12)"
                  >
                    {{ currentSpeaker.name }}
                  </td>

                  <td
                    style="padding: 0px; width:  72px; max-width:  72px; min-width:  72px; color: white; background: #627f90; border-bottom: thin solid rgba(0,0,0,.12)"
                    v-if="meeting.askToSpeak"
                  >
                    <v-tooltip
                      v-if="activeSpeakerId.speakerId === currentSpeaker.id"
                      left
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          @click="
                            activeSpeaker({ name: 'Ordförande', id: null })
                          "
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon
                            v-if="
                              activeSpeakerId.speakerId === currentSpeaker.id
                            "
                            small
                            style="margin-right:5px"
                            color="success"
                          >
                            mdi-account-voice
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Ge ordet till ordförande</span>
                    </v-tooltip>
                  </td>
                </tr>
                <tr v-if="nextSpeaker" style="">
                  <td
                    style="padding-left: 8px; width:  108px; max-width:  108px; min-width: 108px; color: white; background: #627f90; border-bottom: thin solid rgba(0,0,0,.12)"
                  >
                    {{ nextSpeaker.ballots.join(", ") }}
                  </td>
                  <td
                    style="padding: 0; width:  200px; max-width:  200px; min-width:  200px; color: white; background: #627f90; border-bottom: thin solid rgba(0,0,0,.12)"
                  >
                    {{ nextSpeaker.name }}
                  </td>

                  <td
                    style="padding: 0; width:  72px; max-width:  72px; min-width:  72px; color: white; background: #627f90; border-bottom: thin solid rgba(0,0,0,.12)"
                    v-if="meeting.askToSpeak"
                  >
                    <v-tooltip v-if="nextSpeaker.askToSpeak" left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="white"
                          @click="activeSpeaker(nextSpeaker)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon
                            v-if="nextSpeaker.askToSpeak"
                            small
                            style="margin-right:5px"
                            >mdi-hand-front-right
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Ge ordet</span>
                    </v-tooltip>

                    <v-tooltip
                      v-if="activeSpeakerId.speakerId === nextSpeaker.id"
                      left
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          @click="
                            activeSpeaker({ name: 'Ordförande', id: null })
                          "
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon
                            v-if="activeSpeakerId.speakerId === nextSpeaker.id"
                            small
                            style="margin-right:5px"
                            color="success"
                          >
                            mdi-account-voice
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Ge ordet till ordförande</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <div
              class="overflow-y-scroll overflow-x-hidden"
              style="height: 100%;border-radius: 0;"
            >
              <v-simple-table
                light
                dense
                height="100%"
                style="height: 100%;border-radius: 0;"
              >
                <tbody>
                  <tr
                    v-for="elector in displayItems"
                    :key="elector.id"
                    style="height: 36px;"
                  >
                    <td
                      style="padding-left: 8px; width:  108px; max-width:  108px; min-width:  108px;"
                    >
                      {{ elector.ballots.join(", ") }}
                    </td>
                    <td
                      style="padding: 0; width:  200px; max-width:  200px; min-width:  200px;"
                    >
                      {{ elector.name }}
                    </td>

                    <td
                      style="padding: 0; width:  57px; max-width:  57px; min-width:  57px;"
                      v-if="meeting.askToSpeak"
                    >
                      <v-tooltip v-if="elector.askToSpeak" left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            @click="activeSpeaker(elector)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon
                              v-if="elector.askToSpeak"
                              small
                              style="margin-right:5px"
                              >mdi-hand-front-right
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Ge ordet</span>
                      </v-tooltip>

                      <v-tooltip
                        v-if="activeSpeakerId.speakerId === elector.id"
                        left
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            @click="
                              activeSpeaker({ name: 'Ordförande', id: null })
                            "
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon
                              v-if="activeSpeakerId.speakerId === elector.id"
                              small
                              style="margin-right:5px"
                              color="success"
                            >
                              mdi-account-voice
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Ge ordet till ordförande</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
            <v-card flat style="background: #627f90;border-radius: 0px;">
              <v-btn text icon @click="decPage">
                <v-icon>mdi-arrow-left-bold-circle-outline</v-icon>
              </v-btn>
              <span>Sida {{ activePage + 1 }} / {{ pageCount }}</span>
              <v-btn text icon @click="incPage">
                <v-icon>mdi-arrow-right-bold-circle-outline</v-icon>
              </v-btn>
            </v-card>
          </v-card>
        </div>
      </div>
    </div>
    <div class="meeting-layout-bottom"></div>

    <approve-publish-meeting :meeting="meeting"></approve-publish-meeting>
    <information-about-status></information-about-status>
  </div>
</template>

<script>
import EditMeeting from "@/components/meetings/EditMeeting.vue";
import ApprovePublishMeeting from "@/components/meetings/ApprovePublishMeeting.vue";
import InformationAboutStatus from "@/components/meetings/InformationAboutStatus.vue";
import Agenda from "@/components/agenda/Agenda.vue";
import CreateDecisionPoint from "@/components/decisionPoints/CreateDecisionPoint.vue";
import EditDecisionPoint from "@/components/decisionPoints/EditDecisionPoint.vue";
import BallotsAndMandates from "@/components/meetings/BallotsAndMandates.vue";
import SpeakerTime from "@/components/meetings/SpeakerTime.vue";
import Invite from "@/components/meetings/Invite.vue";
import BallotsStats from "@/components/meetings/BallotsStats.vue";
import UploadAgendaItems from "@/components/agenda/UploadAgendaItems.vue";
import UploadBallots from "@/components/meetings/UploadBallots.vue";
import Files from "@/components/meetings/Files.vue";
import UserMenu from "@/components/UserMenu";

const collator = new Intl.Collator("en", {
  numeric: true,
  sensitivity: "base"
});

var textAddPayment = "Lägg till betalningsmetod";

export default {
  components: {
    UserMenu,
    EditMeeting,
    ApprovePublishMeeting,
    InformationAboutStatus,
    Agenda,
    CreateDecisionPoint,
    EditDecisionPoint,
    BallotsAndMandates,
    SpeakerTime,
    Invite,
    BallotsStats,
    UploadAgendaItems,
    UploadBallots,
    Files
  },
  data() {
    return {
      page: 0,
      pageSize: 100,
      search: "",
      visiblePoints: [],
      stateItems: [],
      dropdownState: 0,
      intervalTimer: null,
      decisionsSelect: null
    };
  },
  computed: {
    state() {
      return this.getState(this.meeting);
    },
    stateColor() {
      return "success";
    },
    weightedVoteOptional() {
      return this.meeting.voteWeightModel === "samfallighet";
    },
    meeting() {
      return this.$store.getters["meetings/getMeeting"](
        this.$route.params.meetingId
      );
    },
    organization() {
      return this.$store.getters["organizations/getOrganization"](
        this.meeting.organizationId
      );
    },
    activeSpeakerId() {
      return this.$store.getters["meetings/getState"];
    },
    decisionPoints() {
      return this.$store.getters["meetings/getDecisionPoints"];
    },
    ballotsAndMandates() {
      let electors = {};
      let delegations = {};
      let ballots = this.meeting.ballots;
      let mandates = this.$store.getters["meetings/getMandates"];

      /* electors will look like this
      {
        yyyymmddxxxx: {
          ssn: yyyymmddxxxx,
          ballots: [ballotId],
          present: true/false,
          delegatedTo: yyyymmddxxxx
          shares: [balotShares]
        }
      }
      */

      // Create base list of ssn and ballots
      Object.keys(ballots).forEach(function(ballot) {
        let ssns = ballots[ballot].ssn;
        let shares =
          ballots[ballot].shares != null ? ballots[ballot].shares : 1;
        ssns.forEach(ssn => {
          if (electors[ssn] == null) {
            electors[ssn] = { ssn: ssn, ballots: [], shares: [] };
          }
          electors[ssn].ballots.push(ballot);
          electors[ssn].shares.push(shares);
        });
      });

      // Decorate items with delegatedTo
      mandates.forEach(mandate => {
        if (mandate.ssn !== mandate.id) {
          const elector = electors[mandate.id];
          if (elector) {
            elector.delegatedTo = mandate.ssn;
            if (delegations[mandate.ssn] == null) {
              delegations[mandate.ssn] = [];
            }
            delegations[mandate.ssn].push(elector);
          }
        }
      });

      const delegatedTos = {};

      Object.values(electors).forEach(dElector => {
        if (dElector.delegatedTo) {
          delegatedTos[dElector.delegatedTo] = dElector;
        }
      });

      // Set presence for any present elector
      mandates.forEach(mandate => {
        if (mandate.ssn === mandate.id && mandate.presence != null) {
          const elector = electors[mandate.id];

          if (elector != null) {
            elector.present = true;

            const dElector = delegatedTos[mandate.id];

            if (dElector) {
              dElector.present = true;
            }

            // Object.values(electors).forEach(dElector => {
            //   if (dElector.delegatedTo === mandate.id) {
            //     dElector.present = true;
            //   }
            // });
          }
        }
      });

      // Return an array of electors
      return Object.values(electors)
        .map(elector => {
          elector.ballots = elector.ballots.sort((j, k) =>
            collator.compare(j, k)
          );
          return elector;
        })
        .sort((a, b) => {
          const aBallots = a.ballots.join(",");
          const bBallots = b.ballots.join(",");

          return collator.compare(aBallots, bBallots);
        })
        .sort((a, b) => {
          if (a.present === b.present) {
            return 0;
          } else if (a.present === true && b.present !== true) {
            return -1;
          } else if (a.present === false && b.present !== false) {
            return 1;
          }
        });
    },
    mandates() {
      return this.$store.getters["meetings/getMandates"];
    },
    electors() {
      let electors = this.$store.getters["meetings/getElectors"];

      if (this.meeting.askToSpeak) {
        electors = electors
          .sort((a, b) => {
            return collator.compare(a.ballots[0], b.ballots[0]);
          })
          .sort((a, b) => {
            // equal items sort equally
            if (a.askToSpeak === b.askToSpeak) {
              return 0;
            }
            // nulls sort after anything else
            else if (a.askToSpeak === null || a.askToSpeak === undefined) {
              return 1;
            } else if (b.askToSpeak === null || b.askToSpeak === undefined) {
              return -1;
            } else {
              return (
                a.askToSpeak.toDate().getTime() -
                b.askToSpeak.toDate().getTime()
              );
            }
          })
          .sort((a, b) => {
            if (a.id === this.activeSpeakerId.speakerId) {
              return -1;
            } else if (b.id === this.activeSpeakerId.speakerId) {
              return 1;
            } else {
              return 0;
            }
          });
      }
      return electors;
    },
    isOpen() {
      return this.meeting.adminOpened && !this.meeting.closed;
    },
    numberOfDelegates() {
      let delegates = 0;
      let electors = this.$store.getters["meetings/getElectors"];

      electors.forEach(elector => {
        delegates += elector.delegated.length;
      });

      return delegates;
    },
    isWeightedVotes() {
      if (this.meeting.voteWeightModel) {
        let voteModel = this.meeting.voteWeightModel;
        return voteModel === "weighted" || voteModel === "samfallighet";
      } else {
        return false;
      }
    },
    ballotWidth() {
      return this.isWeightedVotes && this.state < 3 ? "500px" : "400px";
    },
    pageCount() {
      return Math.ceil(this.filteredItems.length / this.pageSize);
    },
    activePage() {
      if (this.page > this.pageCount) {
        return this.pageCount - 1;
      } else {
        return this.page;
      }
    },
    filteredItems() {
      const searchTerm = this.search.toLowerCase();
      const filtered = this.electors.filter(
        item =>
          item.id.includes(searchTerm) ||
          item.name.toLowerCase().includes(searchTerm) ||
          item.delegated
            .map(itm => itm.ssn)
            .join(" ")
            .includes(searchTerm) ||
          item.ballots
            .join(" ")
            .toLowerCase()
            .includes(searchTerm)
      );
      if (filtered && filtered.length > 0 && filtered[0]) {
        // if (this.nextSpeaker && filtered[0].id === this.nextSpeaker.id)
        //   filtered.shift();
        const speakers = filtered.filter(elector => elector.askToSpeak);
        const firstElector = speakers[0];
        let currentActiveSpeakerId = null;
        if (this.activeSpeakerId) {
          currentActiveSpeakerId = this.activeSpeakerId.speakerId;
        }
        if (firstElector) {
          return filtered.filter(
            itm =>
              itm.id !== firstElector.id && itm.id !== currentActiveSpeakerId
          );
        } else {
          return filtered.filter(itm => itm.id !== currentActiveSpeakerId);
        }
      } else {
        return filtered;
      }
    },
    displayItems() {
      return this.filteredItems.slice(
        this.activePage * this.pageSize,
        this.activePage * this.pageSize + this.pageSize
      );
    },
    nextSpeaker() {
      if (this.electors) {
        const speakers = this.electors.filter(elector => elector.askToSpeak);
        const firstElector = speakers[0];
        if (firstElector && firstElector.askToSpeak) {
          return firstElector;
        }
      }
      return null;
    },
    currentSpeaker() {
      if (this.meeting.askToSpeak) {
        const electors = this.$store.getters["meetings/getElectors"];
        return electors.find(
          elector => elector.id === this.activeSpeakerId.speakerId
        );
      } else {
        return null;
      }
    },
    standardDecisions() {
      let selectedContract = this.$store.getters["contracts/contract"](
        this.meeting.contractId
      );
      if (selectedContract && selectedContract.standardDecisions) {
        return selectedContract.standardDecisions;
      } else {
        return {};
      }
    },
    hasStandardDecisions() {
      return Object.keys(this.standardDecisions).length > 0;
    }
  },
  watch: {
    meeting(meeting) {
      this.setState(meeting);
    }
  },
  methods: {
    async copyDesicion(decisionPoint) {
      let newpoint = {
        meetingId: this.meeting.id,
        closed: null,
        opened: null,
        openVote: decisionPoint.openVote,
        text: decisionPoint.text,
        type: decisionPoint.type
      };
      if (decisionPoint.forceChoices) {
        newpoint.forceChoices = decisionPoint.forceChoices;
      }
      if (decisionPoint.alternatives) {
        newpoint.alternatives = decisionPoint.alternatives;
      }
      if (decisionPoint.choices) {
        newpoint.choices = decisionPoint.choices;
      }
      if (decisionPoint.forceUnweighted) {
        newpoint.forceUnweighted = decisionPoint.forceUnweighted;
      }

      await this.$store.dispatch("meetings/createDecisionPoint", newpoint);
    },
    isDesicionEditable(decisionPoint) {
      if (decisionPoint.opened) {
        return false;
      } else if (decisionPoint.closed) {
        return false;
      } else {
        return true;
      }
    },
    decPage() {
      this.page--;
      if (this.page < 0) {
        this.page = 0;
      }
    },
    incPage() {
      this.page++;
      if (this.page > this.pageCount - 1) {
        this.page = this.pageCount - 1;
      }
    },
    screenUrl(meeting) {
      return `/screen/${meeting.id}`;
    },
    manualVotesUrl(meeting) {
      return `/manualVotes/${meeting.id}`;
    },
    sortedResults(results) {
      let r = Array.from(results);
      return r.sort((a, b) => b.result - a.result);
    },
    extendResults(point) {
      let resultsToUse = point.results
        ? Array.from(point.results)
        : Array.from(point.preliminaryResult);
      if (point.alternatives) {
        let altMap = {};
        point.alternatives.forEach(
          value => (altMap[value] = { vote: value, result: 0 })
        );
        resultsToUse.forEach(value => delete altMap[value.vote]);
        let result = resultsToUse.concat(Object.values(altMap));
        return result;
      } else {
        //yesno has no alternatives...
        return resultsToUse;
      }
    },
    async registerAllMembers() {
      this.$store.dispatch("meetings/registerAllMembers", {
        meeting: this.meeting,
        admin: this.$store.getters["auth/auth"].uid
      });
    },
    async downloadReport() {
      const url = await this.$store.dispatch(
        "meetings/downloadReport",
        this.meeting.id
      );
      window.open(url);
    },
    async downloadReceipt() {
      const url = await this.$store.dispatch(
        "meetings/downloadReceipt",
        this.meeting.id
      );
      window.open(url);
    },
    goToOrganization() {
      const meetingOrganization = this.$store.getters[
        "organizations/getOrganization"
      ](this.meeting.organizationId);

      if (meetingOrganization) {
        this.$router.push({
          name: "organization",
          params: { orgId: this.meeting.organizationId }
        });
      } else {
        this.$router.push({
          name: "home"
        });
      }
    },
    activatePoint(item) {
      const decisionPoint = {
        meetingId: this.meeting.id,
        id: item.id
      };
      this.$store.dispatch("meetings/activateDecisionPoint", decisionPoint);
    },
    deactivatePoint(item) {
      const decisionPoint = {
        meetingId: this.meeting.id,
        id: item.id
      };
      this.$store.dispatch("meetings/deactivateDecisionPoint", decisionPoint);
    },
    getStateText() {
      const currentState = this.getState(this.meeting);
      const stateItem = this.stateItems.find(
        item => item.value === currentState
      );
      if (stateItem) {
        return stateItem.text;
      } else {
        return "Initierar";
      }
    },
    getState(meeting) {
      const published = !!meeting.published;
      const inlet = !!meeting.inlet;
      const open = !!meeting.adminOpened;
      const closed = !!meeting.closed;

      if (closed) {
        return 4;
      }

      if (open) {
        return 3;
      }

      if (inlet) {
        return 2;
      }

      if (published) {
        return 1;
      }

      return 0;
    },
    changeState(state) {
      this.dropdownState = state;
      switch (state) {
        case 1:
          if (!this.meeting.published) {
            if (
              Object.keys(this.meeting.ballots).length <= 5 ||
              this.meeting.contractId ||
              this.meeting.stripePaymentMethod
            ) {
              this.$root.$emit("approvePublish");
            } else {
              this.addPaymentSnackbar();
            }
          }
          break;

        case 2:
          this.$store.dispatch("meetings/openMeetingInlet", this.meeting.id);
          break;

        case 3:
          if (
            Object.keys(this.meeting.ballots).length <= 5 ||
            this.meeting.contractId ||
            this.meeting.stripePaymentMethod
          ) {
            this.$store.dispatch("meetings/openMeeting", this.meeting.id);
          } else {
            this.addPaymentSnackbar();
          }
          break;

        case 4:
          this.$store.dispatch("meetings/closeMeeting", this.meeting.id);
          break;
      }
    },
    setState(meeting) {
      if (!meeting) {
        return;
      }
      const state = this.getState(meeting);
      this.dropdownState = state;
      const items = [];

      const unpublished = state > 0 ? null : "Opublicerat möte";
      if (unpublished) items.push({ text: unpublished, value: 0 });

      const published = meeting.published
        ? "1. Möte publicerat"
        : "1. Publicera möte";
      const ballots = Object.keys(meeting.ballots || {});
      const paid = meeting.isPaidFor;
      const hasContract = !!meeting.contractId;
      const isPublished = !!meeting.published;
      const hasStripe = !!meeting.stripePaymentMethod;

      items.push({
        text: published,
        value: 1,
        disabled:
          state > 1 ||
          (!hasContract &&
            !isPublished &&
            ballots.length > 5 &&
            !paid &&
            !hasStripe)
      });
      const inlet = meeting.inlet
        ? "2. Närvaroregistrering"
        : "2. Öppna närvaroregistrering";
      items.push({ text: inlet, value: 2, disabled: state > 3 || state < 1 });
      const open = meeting.adminOpened ? "3. Möte öppnat" : "3. Öppna möte";
      items.push({ text: open, value: 3, disabled: state > 4 || state < 2 });
      const closed = meeting.closed ? "4. Möte stängt" : "4. Stäng möte";
      items.push({ text: closed, value: 4, disabled: state < 3 });

      this.stateItems = items;

      if (meeting.error && meeting.error === "noPaymentMethod") {
        this.addPaymentSnackbar();
        this.$store.dispatch("meetings/clearError", meeting.id);
      }
    },
    translateResult(result) {
      switch (result) {
        case "no":
          return "Nej";
        case "yes":
          return "Ja";
        case "":
          return "Ej röstat";
        default:
          return result;
      }
    },
    isVisible(id) {
      return this.visiblePoints.includes(id);
    },
    toggleVisible(id) {
      if (this.isVisible(id)) {
        this.visiblePoints = this.visiblePoints.filter(el => el !== id);
      } else {
        this.visiblePoints.push(id);
      }
    },
    addPaymentSnackbar() {
      this.$store.commit("snackbar/push", {
        text: textAddPayment,
        icon: "mdi-credit-card-check-outline",
        accept: () => {
          this.$root.$emit("missingPaymentMetod");
        },
        deny: () => {}
      });
    },
    openStatusInformationModal() {
      this.$root.$emit("openStatusInformationModal");
    },
    activeSpeaker(elector) {
      this.$store.dispatch("meetings/updateSpeaker", {
        meetingId: this.meeting.id,
        elector
      });
    },
    gotoMembers() {
      console.log("goToMembers");
      console.log(this.meeting.id);

      this.$router.push({
        name: "members",
        params: { meetingId: this.meeting.id }
      });
    },
    fillDecisions() {
      let selectedDecisions = this.standardDecisions[this.decisionsSelect];
      if (selectedDecisions) {
        this.$store.dispatch("meetings/importStandardDecisions", {
          meetingId: this.meeting.id,
          decisions: selectedDecisions
        });
      }
    }
  },
  async mounted() {
    await this.$store.dispatch(
      "meetings/stateListener",
      this.$route.params.meetingId
    );
    await this.$store.dispatch(
      "meetings/decisionListener",
      this.$route.params.meetingId
    );
    await this.$store.dispatch(
      "meetings/mandatesListener",
      this.$route.params.meetingId
    );
    await this.$store.dispatch(
      "meetings/electorsListener",
      this.$route.params.meetingId
    );
    this.setState(this.meeting);
    this.$root.$on("setStateMeeting", () => {
      this.dropdownState = 0;
    });
  },
  beforeRouteEnter(to, from, next) {
    next(self => {
      self.intervalTimer = setInterval(function() {
        self.decisionPoints.map(async point => {
          if (self.isOpen && !point.closed && point.opened) {
            await self.$cloud.triggerPreliminaryElectionResult({
              meetingId: self.meeting.id,
              electionId: point.id
            });
          }
        });
      }, 1000);
    });
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.intervalTimer);
    next();
  }
};
</script>

<style>
#meeting .error--text {
  color: rgba(255, 255, 255, 0.7) !important;
}

.meeting-container {
  height: 100vh;
  display: grid;
  grid-template-columns: 1fr 1fr min-content;
  grid-template-rows: min-content min-content 1fr 0px;
  gap: 20px 20px;
  grid-template-areas:
    "meeting-layout-top meeting-layout-top meeting-layout-top"
    "meeting-left-top meeting-middle-top meeting-right"
    "meeting-left-content meeting-middle-content meeting-right"
    "meeting-layout-bottom meeting-layout-bottom meeting-layout-bottom";
}

.meeting-layout-top {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  background: #002435;
  -webkit-box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);
  box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);
  grid-area: meeting-layout-top;
}
.meeting-layout-bottom {
  grid-area: meeting-layout-bottom;
}

.meeting-left-top {
  padding-left: 16px;
  grid-area: meeting-left-top;
}

.meeting-middle-top {
  grid-area: meeting-middle-top;
}

.meeting-right {
  padding-right: 16px;
  grid-area: meeting-right;
  height: 100%;
}

.meeting-right-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.meeting-right-content {
  flex: 1 1 auto;
  min-height: 0;
  margin-top: 20px;
}

.meeting-left-content {
  padding-left: 16px;
  padding-bottom: 16px;
  grid-area: meeting-left-content;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.meeting-middle-content {
  grid-area: meeting-middle-content;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.meeting-top-container {
  display: grid;
  grid-template-columns: 36px auto 1fr auto auto auto;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-template-areas: "meeting-top-logo meeting-top-back meeting-top-left meeting-top-middle meeting-top-right meeting-top-usermenu";
}

.meeting-top-logo {
  padding-top: 7px;
  grid-area: meeting-top-logo;
  margin-right: 12px;
  align-self: end;
}

.meeting-top-back {
  grid-area: meeting-top-back;
}

.meeting-top-left {
  margin-left: 12px;
  align-self: center;
  grid-area: meeting-top-left;
}

.meeting-top-middle {
  grid-area: meeting-top-middle;
}

.meeting-top-right {
  grid-area: meeting-top-right;
}

.meeting-top-usermenu {
  grid-area: meeting-top-usermenu;
}

.row-container {
  display: grid;
  grid-template-columns: 1fr min-content;
  grid-template-rows: 1fr;
  gap: 0 0px;
  grid-template-areas: "row-left row-icon";
}

.row-left {
  grid-area: row-left;
}

.row-icon {
  grid-area: row-icon;
}

.decision-container {
  display: grid;
  grid-template-columns: min-content 1fr min-content;
  grid-template-rows: min-content min-content;
  gap: 0px 0px;
  grid-template-areas:
    "decision-icon decision-text decision-edit"
    "decision-icon decision-text decision-unfold";
}

.decision-icon {
  grid-area: decision-icon;
  padding-left: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
}

.decision-text {
  grid-area: decision-text;
  padding-top: 16px;
  padding-bottom: 16px;
}

.decision-edit {
  grid-area: decision-edit;
}

.decision-unfold {
  grid-area: decision-unfold;
  text-align: right;
  vertical-align: bottom;
  align-self: end;
}

.icon-button-container {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-template-areas: "icon-button-text icon-button-icon";
}
.icon-button-text {
  grid-area: icon-button-text;
  align-self: self-end;
}
.icon-button-icon {
  grid-area: icon-button-icon;
}
</style>
